import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { formats } from '../../data/site';
export function Formats() {
  return <section className="bg-ivory" data-id="element-57" data-mp="qjxmc0p1tmav">
      <div className="mx-auto max-w-page px-6 py-20 lg:px-10 lg:py-28" data-id="element-58" data-mp="llw2venpnkyv">
        <h2 className="max-w-xl font-serif text-3xl font-light leading-tight text-ink sm:text-[2.75rem]" data-id="element-59" data-mp="gnkocqmh0mab">
          Pratiquer au studio, ou depuis votre salon
        </h2>

        <div className="mt-14 grid gap-12 lg:grid-cols-2 lg:gap-10" data-id="element-60" data-mp="1e98n3i6efgp0">
          {formats.map(format => <article key={format.to} className="flex h-full flex-col" data-id="element-61" data-mp="19af9lpr43pou">
              <img src={format.image} alt={format.imageAlt} className="aspect-[4/3] w-full object-cover" data-id="element-62" data-mp="14bkh1w3cemrj" />
              <p className="mt-6 text-xs uppercase tracking-[0.2em] text-sage-deep" data-id="element-63" data-mp="10bad0oz426fb">{format.eyebrow}</p>
              <h3 className="mt-3 font-serif text-2xl text-ink" data-id="element-64" data-mp="3p4p8n5a8z5ih">{format.title}</h3>
              <p className="mt-3 leading-relaxed text-ink/70" data-id="element-65" data-mp="3l07tjjeu1ge1">{format.description}</p>
              <ul className="mt-5 space-y-2 text-sm text-ink/60" data-id="element-66" data-mp="11i160vfnog7b">
                {format.points.map(point => <li key={point} className="flex gap-3" data-id="element-67" data-mp="16fauo8v80nu3">
                    <span className="mt-[9px] h-px w-4 shrink-0 bg-ink/30" aria-hidden="true" data-id="element-68" data-mp="sgkxkt8eio5q" />
                    {point}
                  </li>)}
              </ul>
              <Link to={format.to} className="mt-auto inline-flex items-center gap-2 pt-8 text-sm text-ink transition-colors duration-150 ease-soft hover:text-sage-deep" data-id="element-69" data-mp="iqi3sqtgh66c">
                En savoir plus
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="8tn62a50b9t4" />
              </Link>
            </article>)}
        </div>
      </div>
    </section>;
}